(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ckh-scrolling-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initCkh3(sec){
    var slides = sec.querySelectorAll('.ckh3__slide');
    var dots   = sec.querySelectorAll('.ckh3__dot[data-idx]');
    if(slides.length < 2) return;
    var cur = 0, timer;
    function goTo(n){
      slides[cur].classList.remove('ckh3__slide--active');
      dots[cur] && dots[cur].classList.remove('ckh3__dot--on');
      cur = ((n % slides.length) + slides.length) % slides.length;
      slides[cur].classList.add('ckh3__slide--active');
      dots[cur] && dots[cur].classList.add('ckh3__dot--on');
    }
    function start(){ timer = setInterval(function(){ goTo(cur+1); }, 4200); }
    function reset(){ clearInterval(timer); start(); }
    dots.forEach(function(d,i){ d.addEventListener('click',function(){ goTo(i); reset(); }); });
    start();
  }
  function run(){
    document.querySelectorAll('.ckh3').forEach(initCkh3);
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
